module.exports = __webpack_public_path__ + "static/img/95561.ef41163.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/95561.png
// module id = 9fb/
// module chunks = 18